// todo need to use NoteInterface instead
export class CreateNote {
  noteType: string;
  category: string;
  noteDescription: string;
  businessUnitId: string;
  createdBy: string;
  memberId: string;
  userBusinessUnitId: string;
}

export class NoteInterface {
  noteType: string;
  category: string;
  noteDescription: string;
  businessUnitId: string;
  createdBy: string;
  userBusinessUnitId: string;
}

export interface NoteViewInterface {
  noteID: string;
  category: string;
  noteCategory: string;
  noteDescription: string;
  createdOn: Date;
  createdBy: string;
  memberId: string;
  noteType: string;
  isActive: boolean;
  priority: boolean;
}
